const aboutUsAltTextI18nDe = {
  'altTextMonikaAboutUsImage': 'Dr. Monika Hauck Gründerin Repair Rebels nachhaltige Mode',
  'altTextAboutUs2Image': 'Repair Rebels online Modereparatur Service',
};

export default aboutUsAltTextI18nDe;
